import React from "react";
import { LocalizedText } from "../../../components/i18n/LocalizedText.js";
import { isEmptyCellValue, EmptyLabel, dashCharacter } from "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import { AutoAdjustedWidthTooltip } from "../../../components/tooltip/AutoAdjustedWidthTooltip.js";
import "@mui/material";
import "../../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import { StyledTooltip } from "../../../components/tooltip/Tooltip.js";
import "../../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import { TransactionType, ReasonCode } from "../../../contract/pam.js";
import "moment-timezone";
import { formatSnakeCaseEnumValue } from "../../../utils/enum.js";
import "react-intl";
import { localizedReasonCode } from "../sharedLocalization.js";
function TransactionMethod({ transaction_type, payment_method_name }) {
  let value;
  switch (transaction_type) {
    case TransactionType.Credit:
    case TransactionType.Debit:
      value = getReasonCode(payment_method_name);
      break;
    case TransactionType.PokerAddonCredit:
    case TransactionType.PokerAddonDebit:
    case TransactionType.PokerFlipsPayout:
    case TransactionType.PokerFlipsWager:
      value = formatSnakeCaseMethodWithPrefix(payment_method_name, "GAME_TRANSACTION_");
      break;
    case TransactionType.MttCredit:
    case TransactionType.MttDebit:
      value = formatSnakeCaseMethodWithPrefix(payment_method_name, "MTT_SOURCE_");
      break;
    default:
      value = payment_method_name ?? dashCharacter;
      break;
  }
  function getReasonCode(reasonCode) {
    return reasonCode && Object.values(ReasonCode).some((o) => o === reasonCode) ? localizedReasonCode[reasonCode] : reasonCode ?? dashCharacter;
  }
  function formatSnakeCaseMethodWithPrefix(methodName, prefix) {
    const valueWithoutPrefix = methodName?.replace(prefix, "");
    return formatSnakeCaseEnumValue(valueWithoutPrefix);
  }
  return /* @__PURE__ */ React.createElement(
    StyledTooltip,
    {
      element: /* @__PURE__ */ React.createElement(AutoAdjustedWidthTooltip, { value: /* @__PURE__ */ React.createElement(LocalizedText, { label: value }) }),
      title: /* @__PURE__ */ React.createElement(LocalizedText, { label: value })
    }
  );
}
const renderTransactionMethod = (params) => {
  const { transaction_type, payment_method_name } = params.value;
  const isEmpty = isEmptyCellValue(payment_method_name);
  return isEmpty ? /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" }) : /* @__PURE__ */ React.createElement(TransactionMethod, { transaction_type, payment_method_name });
};
export {
  renderTransactionMethod
};
//# sourceMappingURL=MethodCell.js.map
